// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"41412":"d07d6534","72016":"fc22d32c"}[chunkId] || chunkId) + "." + {"41412":"1e759e77c5afedfa","49984":"a4f1ac280c39b6f0","53348":"a47f49226f1701d5","72016":"7418f537f4cd4b02","81238":"e5bbd3f52c77a240"}[chunkId] + ".js";
};